import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ProductLabelRBAC = {
  pageID: 'd74c57a6678d4909c3e6911726667dd4',
  elementID: {
    View: '2495d6b413c0bd7e5fb4b27907bd739f',
    BulkUpload: 'cbd530c934e0fd238fd8b8ee4804a8b3',
    CreateLabel: '60e0b7de8ce293aa31d4f3414bc9fc32',
    EditLabel: '2df3ced46aa1a0ce3be75ebd6d821cd2',
    DeleteLabel: '2933ab6951a5b478b837c1d083bdd84d',
  },
} as const

export const useRBACProductLabelRBACPage = createUseRBAC(ProductLabelRBAC.elementID)

export type UseRBACProductLabelRBACPageType = ReturnType<typeof useRBACProductLabelRBACPage>
